import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import calculationToolsLogo from "../../Images/calculationToolsLogo.png";
import calculationToolsBg from "../../Images/calculationToolsBg.png"
import CalculationToolsFeaturesComponent from "../FeatureComponents/CalculationToolsFeaturesComponent";
import PricesComponent from "../Prices/PricesComponent";
import CalculationToolsFAQsComponent from "../FAQs/CalculationToolsFAQsComponent";
import { Helmet } from "react-helmet-async";
import CalculationToolsFeaturesDetailed from "../FeatureComponents/CalculationToolsFeaturesDetailedComponent";
import CalculationTryNowComponent from "../TryDemo/CalculationTryNowComponent";

export function CalculationToolsPage() {
    const { t } = useTranslation();

    const first_paragraph = t("AboutCalculationToolsFirstParagraph");
    const secoond_paragraph = t("AboutCalculationToolsSecondParagraph");

    const onTryNowClick = () => {
        window.open("https://calctools.bimagine.com/", '_blank');
    };

    return (
        <>
            <Helmet>
                <title>Calculation Tools software</title>
                <meta name="description" content="Calculation Tools Software equips engineers with heating load accurate calculations to enhance thermal efficiency in building designs." />
                <link rel="canonical" href={"https://www.bimagine.com/productsPage/calculationtools"} />
            </Helmet>
            <div className="pt-[50px] bg-#F6F6F6">
                <div className="px-[30px] lg:px-[100px] grid grid-cols-1 xl:grid-cols-2 mb-[30px] gap-[80px] justify-between">
                    <div className="flex items-centermx-auto relative items-center">
                        <img src={calculationToolsBg} alt="calculationToolsBg" className="w-full rounded-[5px]" />
                        <div className="absolute flex justify-center top-0 bottom-0 left-0 right-0">
                            <div className="flex flex-col mx-auto my-auto items-center space-y-1 md:lg:space-y-4 xl:2xl:space-y-4">
                                <img src={calculationToolsLogo} alt="calculationToolsLogo" className="h-[50px] w-[50px] 2xl:h-[70px] 2xl:w-[70px] mx-auto my-auto" />
                                <Typography variant="h1" className="uppercase text-#FFFFFF font-bold text-[20px] md:lg:text-[31px] xl:2xl:text-[31px]">
                                    Calculation Tools
                                </Typography>
                            </div>
                        </div>
                    </div>
                    <div className="mx-auto my-auto">
                        <Typography variant="h2" className="uppercase font-bold text-lg 2xl:text-3xl text-left py-[20px] xl:py-0 xl:pb-[20px] tracking-[0.9px] 2xl:tracking-[1.6px]">
                            {t("AboutCalculationTools")}
                        </Typography>
                        <Typography variant="h3" className="text-base 2xl:text-xl font-light tracking-[0.8px] 2xl:tracking-[1.4px]">
                            {first_paragraph}
                            <br />
                            <br />
                            {secoond_paragraph}
                        </Typography>
                    </div>
                </div>
                <CalculationToolsFeaturesComponent />
                <CalculationToolsFeaturesDetailed />
                <PricesComponent familyTypeValue="CalculationTools" />
                <CalculationTryNowComponent onTryNowClickFunction={onTryNowClick} />
                <CalculationToolsFAQsComponent />
            </div>
        </>
    );
}